module.exports = __webpack_public_path__ + "static/media/comment-alt-check.b6acba5a.svg";